import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

  dataObj;
  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<MessageComponent>, 
  private globalService: GlobalService, private snackBarService: SnackBarService) {
    //TODO: left in the global and snack service to be used by other potential questions
    this.dataObj = data;
  }

  ngOnInit() {
    
  }

  close(isYes) {
    this.dialogRef.close(isYes);
  }

}
